module.exports = __webpack_public_path__ + "img/juan_gonzales.beb5b5f3.jpg";